import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyle } from '../style/index';

export class RecommendationAlertPopup extends React.PureComponent {
  static propTypes = {
    alertMsg: PropTypes.string,
    iconClass: PropTypes.string,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    position: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
  };

  static defaultProps = {
    alertMsg: '',
    iconClass: 'iconba-Unknown',
    position: 'bottom',
    children: null,
  };

  constructor(props) {
    super(props);

    this.popover = null;
    this.state = {
      hiddenText: true,
    };
  }

  showText = () => {
    this.setState({
      hiddenText: false,
    });
  }

  hideText = () => {
    this.setState({
      hiddenText: true,
    });
  }


  render() {
    const {
      alertMsg,
      iconClass,
      classes,
      position,
      children,
    } = this.props;

    return (
      <div className={classes.alertPopupContariner}>
        <span
          className={classNames('iconba', iconClass, classes.alertIcon)}
          onBlur={this.hideText}
          onMouseOut={this.hideText}
          onMouseEnter={this.showText}
        />
        <div
          className={classNames(classes.alertPopup, position)}
          hidden={this.state.hiddenText}
        >
          <span className="arrow" />
          <div className="text">
            {alertMsg}
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export const StyledRecommendationAlertPopup =
  withDefaultStyles(RecommendationAlertPopup, getStyle);


export function addRecommendationAlertPopup({
  container,
  alertMsg,
  position,
  iconClass,
}) {
  ReactDOM.render(
    (<StyledRecommendationAlertPopup
      alertMsg={alertMsg}
      position={position}
      iconClass={iconClass}
    />),
    container
  );
}
